export const isoCountryCodes = {
  "BRUNEI DARUSSALAM": "BN",
  "DEM. REP. OF THE CONGO": "CD",
  "BOLIVIA (PLURINATIONAL STATE OF)": "BO",
  CZECHIA: "CZ",
  "UNITED STATES OF AMERICA": "US",
  AFGHANISTAN: "AF",
  ALBANIA: "AL",
  ALGERIA: "DZ",
  "AMERICAN SAMOA": "AS",
  ANDORRA: "AD",
  ANGOLA: "AO",
  ANGUILLA: "AI",
  ANTARCTICA: "AQ",
  "ANTIGUA AND BARBUDA": "AG",
  ARGENTINA: "AR",
  ARMENIA: "AM",
  ARUBA: "AW",
  AUSTRALIA: "AU",
  AUSTRIA: "AT",
  AZERBAIJAN: "AZ",
  BAHAMAS: "BS",
  BAHRAIN: "BH",
  BANGLADESH: "BD",
  BARBADOS: "BB",
  BELARUS: "BY",
  BELGIUM: "BE",
  BELIZE: "BZ",
  BENIN: "BJ",
  BERMUDA: "BM",
  BHUTAN: "BT",
  BOLIVIA: "BO",
  "BOSNIA AND HERZEGOVINA": "BA",
  BOTSWANA: "BW",
  BRAZIL: "BR",
  "BRITISH INDIAN OCEAN TERRITORY": "IO",
  "BRITISH VIRGIN ISLANDS": "VG",
  BRUNEI: "BN",
  BULGARIA: "BG",
  "BURKINA FASO": "BF",
  BURUNDI: "BI",
  CAMBODIA: "KH",
  CAMEROON: "CM",
  CANADA: "CA",
  "CAPE VERDE": "CV",
  "CAYMAN ISLANDS": "KY",
  "CENTRAL AFRICAN REPUBLIC": "CF",
  CHAD: "TD",
  CHILE: "CL",
  CHINA: "CN",
  "CHRISTMAS ISLAND": "CX",
  "COCOS ISLANDS": "CC",
  COLOMBIA: "CO",
  COMOROS: "KM",
  "COOK ISLANDS": "CK",
  "COSTA RICA": "CR",
  CROATIA: "HR",
  CUBA: "CU",
  CURACAO: "CW",
  CYPRUS: "CY",
  "CZECH REPUBLIC": "CZ",
  "DEMOCRATIC REPUBLIC OF THE CONGO": "CD",
  DENMARK: "DK",
  DJIBOUTI: "DJ",
  DOMINICA: "DM",
  "DOMINICAN REPUBLIC": "DO",
  "EAST TIMOR": "TL",
  ECUADOR: "EC",
  EGYPT: "EG",
  "EL SALVADOR": "SV",
  "EQUATORIAL GUINEA": "GQ",
  ERITREA: "ER",
  ESTONIA: "EE",
  ESWATINI: "SZ",
  ETHIOPIA: "ET",
  "FALKLAND ISLANDS": "FK",
  "FAROE ISLANDS": "FO",
  FIJI: "FJ",
  FINLAND: "FI",
  FRANCE: "FR",
  "FRENCH POLYNESIA": "PF",
  GABON: "GA",
  GAMBIA: "GM",
  GEORGIA: "GE",
  GERMANY: "DE",
  GHANA: "GH",
  GIBRALTAR: "GI",
  GREECE: "GR",
  GREENLAND: "GL",
  GRENADA: "GD",
  GUAM: "GU",
  GUATEMALA: "GT",
  GUERNSEY: "GG",
  GUINEA: "GN",
  "GUINEA-BISSAU": "GW",
  GUYANA: "GY",
  HAITI: "HT",
  HONDURAS: "HN",
  "HONG KONG": "HK",
  HUNGARY: "HU",
  ICELAND: "IS",
  INDIA: "IN",
  INDONESIA: "ID",
  IRAN: "IR",
  IRAQ: "IQ",
  IRELAND: "IE",
  "ISLE OF MAN": "IM",
  ISRAEL: "IL",
  ITALY: "IT",
  "IVORY COAST": "CI",
  JAMAICA: "JM",
  JAPAN: "JP",
  JERSEY: "JE",
  JORDAN: "JO",
  KAZAKHSTAN: "KZ",
  KENYA: "KE",
  KIRIBATI: "KI",
  KOSOVO: "XK",
  KUWAIT: "KW",
  KYRGYZSTAN: "KG",
  LAOS: "LA",
  LATVIA: "LV",
  LEBANON: "LB",
  LESOTHO: "LS",
  LIBERIA: "LR",
  LIBYA: "LY",
  LIECHTENSTEIN: "LI",
  LITHUANIA: "LT",
  LUXEMBOURG: "LU",
  MACAU: "MO",
  "NORTH MACEDONIA": "MK",
  MACEDONIA: "MK",
  MADAGASCAR: "MG",
  MALAWI: "MW",
  MALAYSIA: "MY",
  MALDIVES: "MV",
  MALI: "ML",
  MALTA: "MT",
  "MARSHALL ISLANDS": "MH",
  MAURITANIA: "MR",
  MAURITIUS: "MU",
  MAYOTTE: "YT",
  MEXICO: "MX",
  MICRONESIA: "FM",
  MOLDOVA: "MD",
  MONACO: "MC",
  MONGOLIA: "MN",
  MONTENEGRO: "ME",
  MONTSERRAT: "MS",
  MOROCCO: "MA",
  MOZAMBIQUE: "MZ",
  MYANMAR: "MM",
  NAMIBIA: "NA",
  NAURU: "NR",
  NEPAL: "NP",
  NETHERLANDS: "NL",
  "NETHERLANDS ANTILLES": "AN",
  "NEW CALEDONIA": "NC",
  "NEW ZEALAND": "NZ",
  NICARAGUA: "NI",
  NIGER: "NE",
  NIGERIA: "NG",
  NIUE: "NU",
  "NORTH KOREA": "KP",
  "NORTHERN MARIANA ISLANDS": "MP",
  NORWAY: "NO",
  OMAN: "OM",
  PAKISTAN: "PK",
  PALAU: "PW",
  PALESTINE: "PS",
  PANAMA: "PA",
  "PAPUA NEW GUINEA": "PG",
  PARAGUAY: "PY",
  PERU: "PE",
  PHILIPPINES: "PH",
  PITCAIRN: "PN",
  POLAND: "PL",
  PORTUGAL: "PT",
  "PUERTO RICO": "PR",
  QATAR: "QA",
  "REPUBLIC OF THE CONGO": "CG",
  REUNION: "RE",
  ROMANIA: "RO",
  RUSSIA: "RU",
  RWANDA: "RW",
  "SAINT BARTHELEMY": "BL",
  "SAINT HELENA": "SH",
  "SAINT KITTS AND NEVIS": "KN",
  "SAINT LUCIA": "LC",
  "SAINT MARTIN": "MF",
  "SAINT PIERRE AND MIQUELON": "PM",
  "SAINT VINCENT AND THE GRENADINES": "VC",
  SAMOA: "WS",
  "SAN MARINO": "SM",
  "SAO TOME AND PRINCIPE": "ST",
  "SAUDI ARABIA": "SA",
  SENEGAL: "SN",
  SERBIA: "RS",
  SEYCHELLES: "SC",
  "SIERRA LEONE": "SL",
  SINGAPORE: "SG",
  "SINT MAARTEN": "SX",
  SLOVAKIA: "SK",
  SLOVENIA: "SI",
  "SOLOMON ISLANDS": "SB",
  SOMALIA: "SO",
  "SOUTH AFRICA": "ZA",
  "SOUTH KOREA": "KR",
  "SOUTH SUDAN": "SS",
  SPAIN: "ES",
  "SRI LANKA": "LK",
  SUDAN: "SD",
  "SURI NAME": "SR",
  "SVALBARD AND JAN MAYEN": "SJ",
  SWAZILAND: "SZ",
  SWEDEN: "SE",
  SWITZERLAND: "CH",
  SYRIA: "SY",
  TAIWAN: "TW",
  TAJIKISTAN: "TJ",
  TANZANIA: "TZ",
  THAILAND: "TH",
  TOGO: "TG",
  TOKELAU: "TK",
  TONGA: "TO",
  "TRIN ID AD AND TOBAGO": "TT",
  TUNISIA: "TN",
  TURKEY: "TR",
  TURKMENISTAN: "TM",
  "TURKS AND CAICOS ISLANDS": "TC",
  TUVALU: "TV",
  "U.S. VIRGIN ISLANDS": "VI",
  UGANDA: "UG",
  UKRAINE: "UA",
  "UNITED ARAB EMIRATES": "AE",
  "UNITED KINGDOM": "GB",
  "UNITED STATES": "US",
  URUGUAY: "UY",
  UZBEKISTAN: "UZ",
  VANUATU: "VU",
  VATICAN: "VA",
  VENEZUELA: "VE",
  VIETNAM: "VN",
  "WALLIS AND FUTUNA": "WF",
  "WESTERN SAHARA": "EH",
  YEMEN: "YE",
  ZAMBIA: "ZM",
  ZIMBABWE: "ZW",
  ENGLAND: "GB-ENG",
  "NORTHERN IRELAND": "GB",
  SCOTLAND: "GB-SCT",
  WALES: "GB-WLS",
};

export const isoCountries = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua And Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia And Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CANADA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CH: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, Democratic Republic",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Ivory Coast",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island & Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  INDONESIA: "Indonesia",
  IR: "Iran, Islamic Republic Of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle Of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "South Korea",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States Of",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russia",
  RUNM: "Russia",
  IDNM: "Indonesia",
  INMR: "India",
  INMR3: "India",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts And Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre And Miquelon",
  VC: "Saint Vincent And Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome And Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia And Sandwich Isl.",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SS: "South Sudan",
  SJ: "Svalbard And Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  SW: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad And Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks And Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UK: "United Kingdom",
  US: "United States",
  UM: "United States Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis And Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  MIDDLEEAST: "Middle East",
  EU: "Europe",
  USM: "United States",
  MXM: "Mexico",
};
